import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

const getHoursDifference = (time: string) => {
  const parsed = dayjs(time);

  if (!parsed.isValid()) return "0h";

  const diffHours = Math.max(dayjs().diff(parsed, "hour"), 0);
  const diffDays = Math.floor(diffHours / 24);
  const diffMonths = Math.floor(diffDays / 30);
  const diffYears = Math.floor(diffMonths / 12);

  if (diffYears >= 1) return `${diffYears}y`;
  if (diffMonths >= 1) return `${diffMonths}m`;
  if (diffDays >= 1) return `${diffDays}d`;

  return `${diffHours}h`;
};

export default getHoursDifference;

export const formatToEnglishDateTime = (time: string): string => {
  const parsed = dayjs(time, "DD.MM.YYYY, HH:mm:ss");

  if (!parsed.isValid()) return "";

  return parsed.format("MMM D YYYY, h:mm A");
};

export const formatTimeAgo = (time: string): string => {
  const parsed = dayjs(time);

  if (!parsed.isValid()) return "";

  const now = dayjs();
  const diffSeconds = Math.max(now.diff(parsed, "second"), 0);

  if (diffSeconds < 60) return "Now";

  const diffMinutes = Math.floor(diffSeconds / 60);
  if (diffMinutes < 60) {
    return `${diffMinutes} minute${diffMinutes !== 1 ? "s" : ""} ago`;
  }

  const diffHours = Math.floor(diffMinutes / 60);
  if (diffHours < 24) {
    return `${diffHours} hour${diffHours !== 1 ? "s" : ""} ago`;
  }

  return parsed.format("MMM D, YYYY");
};

export const formatToShortDate = (time: string): string => {
  const parsed = dayjs(time);

  if (!parsed.isValid()) return "";

  return parsed.format("MM/DD/YYYY");
};

export const formatToLongDate = (time: string): string => {
  const parsed = dayjs(time);

  if (!parsed.isValid()) return "";

  return parsed.format("MMMM D, YYYY");
};
